import { DialogRef } from '@angular/cdk/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { FacilitatorserviceService } from 'src/app/services/facilitatorservice.service';
import { GroupService } from 'src/app/services/groupservice.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-editgroup',
  templateUrl: './editgroup.component.html',
  styleUrls: ['./editgroup.component.scss'],
})
export class EditgroupComponent implements OnInit, OnDestroy {
  private subs = new SubSink();
  public alliedFacilitators: any;
  public hideRequiredControl = new FormControl(true);
  private limit = 1000;
  private page = 1;
  public groupForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    groupName: ['', [Validators.required]],
    facilitatorName: ['', [Validators.required]],
    startDate: ['', [Validators.required]],
    endDate: ['', [Validators.required]],
  });
  public minDate: Date;

  constructor(
    private fb: FormBuilder,
    public dialogRef: DialogRef<EditgroupComponent>,
    private groupsService: GroupService,
    private facilitatorService: FacilitatorserviceService,
    @Inject(MAT_DIALOG_DATA) public data: { fields: any },
    private _snackBar: MatSnackBar,
    private trasnlateService: TranslateService,
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  ngOnInit(): void {
    this.getListFacilitators('', this.page, this.limit);
  }

  public getListFacilitators(search: any, page: number, limit: number): void {
    this.subs.sink = this.facilitatorService
      .getAllFacilitators(search, page, limit, this.data.fields.id_allied, '')
      .subscribe((rta: any) => {
        const { find } = rta;
        this.alliedFacilitators = find;
        this.loadData();
      });
  }

  public editGroup(id: string, body: any, id_facilitator: string): void {
    this.groupsService.update(id, body, id_facilitator).subscribe({
      next: (v) => {
      console.log(v);
      this.loadData();
      },
      error: (e) => {
      const errorMessage = this.extractErrorMessage(e);
      if (errorMessage) {
        this._snackBar.open(errorMessage, 'Cerrar', {
        duration: 3000,
        horizontalPosition: 'right',
        verticalPosition: 'top'
        });
      } else {
        this._snackBar.open('Error al hacer udpate', 'Cerrar', {
        duration: 1500,
        horizontalPosition: 'right',
        verticalPosition: 'top'
        });
      }
      console.error(e);
      },
      complete: () => this.dialogRef.close()
    });
  }

  private loadData(): void {
    const profile = this.data.fields;
    this.minDate = moment(profile.start_date).toDate();
    const startDate = moment(profile.start_date).toDate();
    const endingDate = moment(profile.ending_date).toDate();
    this.groupForm.patchValue({
      groupName: profile.group_name,
      facilitatorName: profile.id_facilitator,
      startDate: startDate,
      endDate: endingDate,
    });
  }

  public sendData(form: FormGroup): void {
    if (form.invalid) {
      this.markFormError(form);
    } else {
      const obj = {
        group_name: this.groupForm.value.groupName,
        start_date: this.groupForm.value.startDate.toISOString(),
        ending_date: this.groupForm.value.endDate.toISOString(),
        id_allied: this.data.fields.id_allied,
      };
      const id = this.data.fields._id;
      const id_facilitator = form.value.facilitatorName;
      this.editGroupSucces(id, obj, id_facilitator);
    }
  }

  private markFormError(form: FormGroup): void {
    return Object.values(form.controls).forEach((control) => {
      control.markAllAsTouched();
    });
  }

  public closeModal(): void {
    this.dialogRef.close();
  }

  private editGroupSucces(id: string, obj: any, id_facilitator: string): void {
    let change = true;
    this.subs.sink = this.trasnlateService
      .get(['ORGANIZATION.grupEditedSucces', 'USERS.undo'])
      .subscribe((valor) => {
        const message = valor['ORGANIZATION.grupEditedSucces'];
        const action = valor['USERS.undo'];
        this._snackBar.open(message, action, {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
        this._snackBar._openedSnackBarRef?.onAction().subscribe(() => {
          change = false;
        });

        this._snackBar._openedSnackBarRef?.afterDismissed().subscribe(() => {
          if (change === true) {
            this.editGroup(id, obj, id_facilitator);
            this.closeModal();
          }
        });
      });
  }

  extractErrorMessage(response: HttpErrorResponse): string | null {
    try {
      // Check if response has error property and errors array
      if (response?.error?.errors && response?.error?.errors?.length > 0) {
        // Return the first error message
        return response.error.errors[0].message;
      }
      return null; // Return null if no error message is found
    } catch (error) {
      console.error('Error extracting message:', error);
      return null;
    }
  }
}
